/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect, memo } from 'react'
import {
  View,
  ScrollView,
  TouchableOpacity,
  ImageBackground,
  Dimensions,
  Linking,
  Platform,
  StatusBar,
} from 'react-native'
import LottieView from 'lottie-react-native'
import PropTypes from 'prop-types'
import LinearGradient from 'react-native-linear-gradient'
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context'
import { Icon } from '@vfgroup-oneplatform/foundation/Components'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager'
import Carousel from 'react-native-snap-carousel'
import WebView from 'react-native-webview'

import RadioGroup from '../../Components/RadioGroup'
import ProgressBar from '../../Components/ProgressBar'


import VfText from '../../Components/VfText'
import VFButton from '../../Components/VFButton'

import images from '../../Themes/Images'
import { winter, summer } from '../../Themes/Themes'

import styles from './QuizGame.Styles'
import { stackAnimatedStyles, stackScrollInterpolator } from './QuizGame.Animations'

const Themes = { winter, summer }
const { width } = Dimensions.get('screen')

function GameSlides({
  selectedAnswer,
  cardState,
  setSelectedAnswer,
  options,
  quizLevel,
  isLoading,
  optionsNr,
  questionNumber,
  quizQuestion,
  quizResults,

}) {

  const [theme] = useState('summer')
  let webViewRef = useRef(null)

  const {
    quizRibbon,
    thumbsUp,
    thumbsDown,
    sadFace,
    successLottie,
    background3,
    primary
  } = Themes[theme]

  const insets = useSafeAreaInsets()


  const cardContent = {
    'active': () => (
      <ScrollView
        nestedScrollEnabled={true}
        contentContainerStyle={styles.activeCardWrapper}
        showsVerticalScrollIndicator={false}>
        <VfText
          size="h5"
          weight="bold"
          align="left"
          style={styles.levelSelectorHeader}
          isLoading={isLoading}
          i18nKey={quizQuestion}
        />
        {isLoading && <VfText
          size="h5"
          weight="bold"
          align="left"
          style={styles.levelSelectorHeader}
          isLoading={true}
          i18nKey="Sa objektiva jane te percaktuara nga UN per zhvillimin e qendrueshem te shoqerise ?"
        />}
        <RadioGroup
          options={options}
          selected={selectedAnswer}
          setSelected={setSelectedAnswer}
          style={styles.radioGroupContainer}
          isLoading={isLoading}
        />
      </ScrollView>
    ),
    'correct': () => (
      <View style={styles.quizCardFeedbackWrapper}>
        <Icon
          name={thumbsUp}
          type="image"
          resizeMode="contain"
          size={110}
          style={styles.quizCardFeedbacIcon}
        />
        <VfText
          size="h4"
          weight="bold"
          align="center"
          isLoading={isLoading}
          style={styles.quizCardFeedbacText}
          i18nKey={quizResults?.title}
        />
      </View>),
    'incorrect': () => (
      <View style={styles.quizCardFeedbackWrapper}>
        <Icon
          name={thumbsDown}
          type="image"
          resizeMode="contain"
          size={110}
          style={styles.quizCardFeedbacIcon}
        />
        <VfText
          size="h4"
          weight="bold"
          isLoading={isLoading}
          align="center"
          style={styles.quizCardFeedbacText}
          i18nKey={quizResults?.title}
        />
        {/* <VfText
          size="body"
          align='center'
          style={styles.quizCardFeedbacText}
          i18nKey="Lorem ipsum dolor sit amet"
        /> */}
      </View>),
    'timeover': () => (
      <View style={styles.quizCardFeedbackWrapper}>
        <Icon
          name={sadFace}
          type="image"
          resizeMode="contain"
          size={110}
          style={styles.quizCardFeedbacIcon}
        />
        <VfText
          size="h4"
          weight="bold"
          isLoading={isLoading}
          align="center"
          style={styles.quizCardFeedbacText}
          i18nKey="quiz_game_oot_question"
        />
        {/* <VfText
          size="body"
          align='center'
          style={styles.quizCardFeedbacText}
          i18nKey="Lorem ipsum dolor sit amet"
        /> */}
      </View>),
    'completed': () => (
      <View style={styles.quizCardFeedbackWrapper}>
        <LottieView
          source={successLottie}
          autoPlay={true}
          style={{ height: 150 }}
          loop={true}
          resizeMode="contain"
          imageAssetsFolder={'../../Images/lottieIcons'}
        />
        <VfText
          size="h4"
          weight="bold"
          align="center"
          isLoading={isLoading}
          style={styles.quizCardFeedbacText}
          i18nKey={quizResults?.title}
        />
        <VfText
          size="h5"
          align="center"
          isLoading={isLoading}
          style={styles.quizCardFeedbacText}
          i18nKey={quizResults?.description}
        />
      </View>),
    'passed': () => (
      <View style={styles.quizCardFeedbackWrapper}>
        <LottieView
          source={successLottie}
          autoPlay={true}
          style={{ height: 150 }}
          loop={true}
          resizeMode="contain"
          imageAssetsFolder={'../../Images/lottieIcons'}
        />
        <VfText
          size="h4"
          weight="bold"
          align="center"
          isLoading={isLoading}
          style={styles.quizCardFeedbacText}
          i18nKey={quizResults?.title}
        />
        <WebView
          ref={ref => { webViewRef = ref }}
          source={{
            html: quizResults?.description,
          }}
          originWhitelist={['*']}
          style={{ width: 320, marginTop: 20 }}
          javaScriptEnabled
          onNavigationStateChange={(event) => {
            if (event.url !== 'about:blank') {
              // this.webview.stopLoading()
              webViewRef.stopLoading()
              Linking.openURL(event.url)
            }
          }}
          startInLoadingState={true}
        />
      </View>),
    'failed': () => {
      return (
        <View style={styles.quizCardFeedbackWrapper}>
          <Icon
            name={sadFace}
            type="image"
            resizeMode="contain"
            size={110}
            style={Platform.OS === 'web' && Dimensions.get('window').width > 700 ? {} : styles.quizCardFeedbacIcon}
          />
          <VfText
            size="h4"
            weight="bold"
            isLoading={isLoading}
            align="center"
            style={styles.quizCardFeedbacText}
            i18nKey={quizResults?.title}
          />
          <div className='test1' dangerouslySetInnerHTML={{ __html: quizResults?.description, }}
            style={{ height: 40, width: '100%', minHeight: 250, fontFamily: 'VodafoneRg' }} />
          {/* <WebView
            ref={ref => { webViewRef = ref }}
           source={{
              html: quizResults?.description,
            }}
            originWhitelist={['*']}
            // style={{ width: 320, marginTop: 20, height: 200 }}
            javaScriptEnabled
            onNavigationStateChange={(event) => {
              if (event.url !== 'about:blank') {
                // this.webview.stopLoading()
                webViewRef.stopLoading()
                Linking.openURL(event.url)
              }
            }}
            startInLoadingState={true}
         /> */}
        </View>)
    },
    'error': () => (
      <View style={styles.quizCardFeedbackWrapper}>
        <Icon
          name={sadFace}
          type="image"
          resizeMode="contain"
          size={110}
          style={styles.quizCardFeedbacIcon}
        />
        <VfText
          size="h4"
          weight="bold"
          align="center"
          isLoading={isLoading}
          style={styles.quizCardFeedbacText}
          i18nKey={"quiz_game_error"}
        />
      </View>),
  }

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <View style={styles.questionSlideWrapper}>
        <ImageBackground source={quizRibbon} style={styles.quizSlideBackground} resizeMode="cover" >
          <VfText
            size="h1"
            weight="bold"
            align="left"
            style={styles.quizGameNumber}
            i18nKey={quizLevel}
          />
        </ImageBackground>
        <VfText
          size="h5"
          align="right"
          style={styles.questionNumber}
          loaderWidth={80}
          isLoading={isLoading}
          placeHolders={[questionNumber, optionsNr]}
          i18nKey={(cardState === 'completed' || cardState === 'failed' || cardState === 'passed') ? 'quiz_game_finished' : 'quiz_game_question_number'}
        />

        <LinearGradient start={{ x: 0.5, y: 0.25 }}
          end={{ x: 0.5, y: 1 }}
          colors={['#D62D2D00', '#9C0101']}
          style={styles.gradientWrapper}>
          <View style={styles.gradientBorder}>
            {cardContent[cardState]()}
          </View>
        </LinearGradient >
      </View >
    )
  }


  return (
    <View style={styles.questionSlideWrapper}>
      <ImageBackground source={quizRibbon} style={styles.quizSlideBackground} resizeMode="cover" >
        <VfText
          size="h1"
          weight="bold"
          align="left"
          style={styles.quizGameNumber}
          i18nKey={quizLevel}
        />
      </ImageBackground>
      <VfText
        size="h5"
        align="right"
        style={styles.questionNumber}
        loaderWidth={80}
        isLoading={isLoading}
        placeHolders={[questionNumber, optionsNr]}
        i18nKey={(cardState === 'completed' || cardState === 'failed' || cardState === 'passed') ? 'quiz_game_finished' : 'quiz_game_question_number'}
      />

      <LinearGradient start={{ x: 0.5, y: 0.25 }}
        end={{ x: 0.5, y: 1 }}
        colors={['#D62D2D00', '#9C0101']}
        style={styles.gradientWrapper}>
        <View style={styles.gradientBorder}>
          {cardContent[cardState]()}
        </View>
      </LinearGradient >
    </View >
  )
}

GameSlides.propTypes = {
  onClose: PropTypes.func,
  quizLevel: PropTypes.string,
  route: PropTypes.object,
  selectedAnswer: PropTypes.func,
  setSelectedAnswer: PropTypes.func,
  options: PropTypes.func,
  index: PropTypes.func,
  isLoading: PropTypes.func,
  cardState: PropTypes.string,
  optionsNr: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  questionNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  quizQuestion: PropTypes.string,
  quizResults: PropTypes.object,
}

const MemoizedGameSlides = memo(GameSlides)

function QuizGame({
  onClose,
  quizLevel,
  optionsNr,
  getLevelOptions,
  goBack,
  putQuizOption,
  getReward,
  levelOptions = {},
}) {
  const [theme] = useState('summer')
  const insets = useSafeAreaInsets()
  const {
    gradient,
    primary,
    quizInfo,
    background3,
  } = Themes[theme]

  const cards = Array(parseInt(optionsNr, 10) + 1).fill('1')
  // const [questionObject, setQuestionObject] = useState({})

  const [isTimePaused, setIsTimePaused] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [buttonLoading, setButtonLoading] = useState(false)
  const [questionNumber, setQuestionNumber] = useState(1)
  const [cardState, setCardState] = useState('active')
  const [correctAnswers, setCorrectAnswers] = useState(0)
  const [selectedAnswer, setSelectedAnswer] = useState()
  const [answerTime, setAnswerTime] = useState()
  const [quizResults, setQuizResults] = useState({})
  const carueselRef = useRef(null)

  useEffect(() => {
    const interval = setInterval(() => {
      if (answerTime === 1) {
        (async () => {
          setIsTimePaused(true)
          setButtonLoading(true)
          const data = levelOptions?.responseObject

          try {
            const res = await putQuizOption(
              data,
              {
                onStart: () => { },
                onError: (e) => {
                  setButtonLoading(false)
                  setCardState('error')
                },
                onSuccess: (success) => {
                  setCardState(success?.state)
                  setCorrectAnswers(success?.correctAnswers)
                  setQuizResults(success)
                  setSelectedAnswer()
                  setButtonLoading(false)
                },
              })

          } catch (e) {
            console.log(e, 'errori')
          }
        })()
        clearInterval(interval)
      }
      if (isTimePaused) {
        clearInterval(interval)

      } else {
        setAnswerTime(prev => prev - 1)
      }

    }, 1000)
    return () => clearInterval(interval)
  }, [answerTime])

  useEffect(() => {
    if (questionNumber <= optionsNr) {
      (async () => {
        try {
          const res = await getLevelOptions(
            questionNumber,
            {
              onStart: () => { setIsLoading(true) },
              onError: (e) => {
                setIsLoading(false)
                setCardState('error')
                setButtonLoading(false)
              },
              onSuccess: (success) => {
                setAnswerTime(success?.dateDiff)
                // setQuestionObject(success)
                setIsLoading(false)
                setButtonLoading(false)
              },
            })

        } catch (e) {
          console.log(e, 'errori')
        }
      })()

    } else {
      (async () => {
        try {

          const res = await getReward(
            {
              onStart: () => { setIsLoading(true) },
              onError: (e) => {
                setIsLoading(false)
                setCardState('error')
                setButtonLoading(false)

              },
              onSuccess: (success) => {

                setQuizResults(success)
                setCardState(success.state)
                setIsLoading(false)
                setButtonLoading(false)

              },
            })

        } catch (e) {
          console.log(e, 'errori')
        }
      })()
    }

    return () => {
    }

  }, [questionNumber])


  const putQuestionMapper = (data, answer) => {
    const dataCopy = data
    dataCopy.relatedProductOffering.find(v => v.id[0].value === answer).type = 'selected'

    return dataCopy
  }

  const buttonStates = {
    'active': {
      type: 'primary',
      disabled: selectedAnswer ? false : true,
      label: 'quiz_game_confirm_button',
      onPress: async () => {
        setIsTimePaused(true)
        setButtonLoading(true)
        const data = putQuestionMapper(levelOptions?.responseObject, selectedAnswer)

        try {
          await putQuizOption(
            data,
            {
              onStart: () => { },
              onError: (e) => {
                setButtonLoading(false)
                setCardState('error')
                setButtonLoading(false)

              },
              onSuccess: (success) => {
                setCardState(success?.state)
                setCorrectAnswers(success?.correctAnswers)
                setQuizResults(success)
                setSelectedAnswer()
                setButtonLoading(false)
              },
            })
        } catch (e) {
          console.log(e, 'errori')
        }
      },
    },
    'timeover': {
      type: 'primary',
      disabled: false,
      label: 'quiz_game_continue_button',
      onPress: () => {
        setIsLoading(true)
        setButtonLoading(true)
        // carueselRef.current.snapToNext()
        setQuestionNumber(prev => prev + 1)
        setCardState('active')
        setIsTimePaused(false)
      },
    },
    'incorrect': {
      type: 'primary',
      label: 'quiz_game_continue_button',
      disabled: false,
      onPress: () => {
        setButtonLoading(true)
        setIsLoading(true)
        // carueselRef.current.snapToNext()
        setQuestionNumber(prev => prev + 1)
        setCardState('active')
        setIsTimePaused(false)
      },
    },
    'correct': {
      type: 'primary',
      disabled: false,
      label: 'quiz_game_continue_button',
      onPress: () => {
        setIsLoading(true)
        setButtonLoading(true)
        // carueselRef.current.snapToNext()
        setQuestionNumber(prev => prev + 1)
        setCardState('active')
        setIsTimePaused(false)
      },
    },
    'completed': {
      type: 'primary',
      disabled: false,
      label: 'quiz_game_play_again_button',
      onPress: () => {
        goBack(1)
      },
    },
    'passed': {
      type: 'primary',
      disabled: false,
      label: 'quiz_game_play_again_button',
      onPress: () => {
        goBack(1)
      },
    },
    'failed': {
      type: 'primary',
      disabled: false,
      label: 'quiz_game_play_again_button',
      onPress: () => {
        goBack(1)
      },
    },
    'error': {
      type: 'primary',
      disabled: false,
      label: 'quiz_game_continue_button',
      onPress: () => {
        goBack(1)
      },
    },
  }

  return (
    <LinearGradient
      colors={gradient}
      useAngle={true}
      angleCenter={{ x: 0.5, y: 0.5 }}
      angle={30}
      style={styles.background}
    >
      <ImageBackground source={background3} style={styles.background} resizeMode="cover" >
        <SafeAreaView
          style={styles.container()}
          edges={['right', 'left']}>
          <ScrollView nestedScrollEnabled={true} contentContainerStyle={styles.scrollContainer(insets.bottom)}>
            <>
              <View style={styles.headerContentWrapper(insets.top)}>
                <TouchableOpacity onPress={() => goBack(1)} disabled={false}>
                  <Icon
                    name={images.close}
                    type="image"
                    resizeMode="contain"
                    size={24}
                    style={styles.closeIcon(primary)}
                  />
                </TouchableOpacity>
              </View>
              {(cardState !== 'completed' && cardState !== 'failed' && cardState !== 'passed') ? <ProgressBar
                description={`${ContentManager.translate('quiz_game_collected_points')} ${correctAnswers}`}
                style={styles.timeBar}
                usedData={answerTime || 0}
                limit={30}
                backgroundColor={Colors.tangerine}
                foregroundColor={Colors.ocean}
                isContentLoading={isLoading}
                isLoading={isLoading}
              /> : <View style={{ height: 69 }} />}
              <Carousel
                ref={c => {
                  carueselRef.current = c
                }}
                layout="stack"
                layoutCardOffset={0}
                data={cards || []}
                renderItem={({ item, index }) => {
                  return (
                    index === 0 ?
                      <MemoizedGameSlides
                        theme={theme}
                        selectedAnswer={selectedAnswer}
                        setSelectedAnswer={setSelectedAnswer}
                        options={levelOptions?.options}
                        optionsNr={optionsNr}
                        quizLevel={quizLevel}
                        isLoading={isLoading}
                        questionNumber={levelOptions?.questionNumber}
                        quizQuestion={levelOptions?.quizQuestion}
                        cardState={cardState}
                        quizResults={quizResults}
                      />
                      :
                      <MemoizedGameSlides
                        theme={theme}
                        cardState={cardState}
                      />
                  )
                }}
                sliderWidth={(width - 300) * 0.8}
                itemWidth={(width - 300) * 0.8}
                itemHeight={288}
                scrollEnabled={false}
                style={styles.caruselContent}
                contentContainerCustomStyle={styles.caruselContent}
                // onSnapToItem={index => onCarouselItemChange(index)}
                initialNumToRender={3}
                scrollInterpolator={stackScrollInterpolator}
                slideInterpolatedStyle={stackAnimatedStyles}
              />

            </>
            <VFButton
              type={'primary'}
              title={buttonStates[cardState].label}
              onPress={buttonStates[cardState].onPress}
              style={styles.quizGameButton}
              disabled={buttonStates[cardState].disabled}
              loadingTitle={'promo_processing_button'}
              isLoading={buttonLoading}
            />
          </ScrollView>
        </SafeAreaView>
      </ImageBackground>
    </LinearGradient >
  )
}
QuizGame.defaultProps = {}

QuizGame.propTypes = {
  onClose: PropTypes.func,
  quizLevel: PropTypes.string,
  route: PropTypes.object,
  optionsNr: PropTypes.number,
  getLevelOptions: PropTypes.func,
  sessionId: PropTypes.string,
  putQuizOption: PropTypes.func,
  getReward: PropTypes.func,
}

export default QuizGame
